const ViewRenderer = require("client/src/view-renderer");
const ViewManager = require("client/src/view-manager");
const ViewContainer = require("client/src/view-container");
const Language = require("core/src/language").default;
const _ = require("core/src/utils/legacy");
const $ = require("jquery");

require("../../css/container-list-view.css");

const DEFAULT_EXCLUDED_CONTAINER_IDS = ["LogoHolder", "user-view", "account_dropdown", "info_dropdown", "cog_modal"];

const ContainerListViewRenderer = function (dependencies) {
	ViewRenderer.call(this);

	this.viewmanager = dependencies.get(ViewManager);
	this.language = dependencies.get(Language);
	this.$root = null;
	this.$list = null;
	this.$summary = null;
	this.$search = null;
	this.$searchClear = null;
	this.$refresh = null;
	this._autoRefreshInterval = null;

	this._options = {
		includeSelf: false,
		refreshIntervalMs: 1000,
	};
	this._search = "";
	this._includeSelf = false;
	this._refreshIntervalMs = 1000;
	this._excludeContainerIDs = DEFAULT_EXCLUDED_CONTAINER_IDS.slice();
	this._runtimeExcludedContainerIDs = [];
	this._tooltips = {};
	this._totalCount = 0;
	this._filteredCount = 0;
	this._pauseAutoRefresh = false;
	this._hoveredContainerID = undefined;
};
ContainerListViewRenderer.viewType = "ContainerListView";
ContainerListViewRenderer.prototype = Object.create(ViewRenderer.prototype);

ContainerListViewRenderer.prototype.onClose = function () {
	this.hideAllTooltips();
	if (this._autoRefreshInterval) {
		clearInterval(this._autoRefreshInterval);
		this._autoRefreshInterval = null;
	}
	this._runtimeExcludedContainerIDs = [];
	this._pauseAutoRefresh = false;
	this._hoveredContainerID = undefined;
	return true;
};

ContainerListViewRenderer.prototype.onReady = function () {
	this.renderContainerList();
	return true;
};

ContainerListViewRenderer.prototype.doRender = function (renderData) {
	this._options = _.defaultsDeep(renderData.options, this._options);
	this._includeSelf = _.resolve(this._options.includeSelf, false) === true;
	this._search = _.get(
		renderData,
		"search",
		_.get(this._options, "search", "")
	);
	this._excludeContainerIDs = this.parseExcludedContainerIDs(
		_.get(this._options, "exclude", [])
	);
	this._tooltips = this.parseTooltips(this._options);

	const refreshIntervalMs = _.parseInt(
		_.get(this._options, "refreshIntervalMs", 1000)
	);
	this._refreshIntervalMs = refreshIntervalMs >= 250 ? refreshIntervalMs : 1000;

	const $root = $('<div class="ContainerListView d-flex flex-column h-100">');
	const $toolbar = $('<div class="container-list-toolbar d-flex gap-2 mb-2">');
	const $searchWrap = $(
		'<div class="container-list-search-wrap input-group input-group-sm flex-grow-1">'
	);
	const $search = $(
		`<input type="text" class="form-control form-control-sm container-list-search" placeholder="${this.language.translate('findContainerPlaceholder')}" />`
	);
	const $searchClear = $(
		'<button type="button" class="btn btn-secondary container-list-search-clear" aria-label="Clear search"><i class="fa fa-times"></i></button>'
	).attr("data-action", "clear-search");
	const $refresh = $(
		'<button type="button" class="btn btn-sm btn-secondary" aria-label="Refresh panels"><i class="fa fa-refresh"></i></button>'
	).attr("data-action", "refresh");
	const $summary = $(
		'<div class="small text-muted mb-2 container-list-summary">'
	);
	const $list = $(
		'<div class="container-list-items flex-grow-1 overflow-auto">'
	);

	if (_.isString(this._search) && this._search.length > 0) {
		$search.val(this._search);
	}

	$searchWrap.append($search);
	$searchWrap.append($searchClear);

	$toolbar.append($searchWrap);
	$toolbar.append($refresh);

	$root.append($toolbar);
	$root.append($summary);
	$root.append($list);

	this.$root = $root;
	this.$list = $list;
	this.$summary = $summary;
	this.$search = $search;
	this.$searchClear = $searchClear;
	this.$refresh = $refresh;

	this.updateRefreshTooltip();
	this.updateSearchClearButton();

	this.$root.on("click", '[data-bs-toggle="tooltip"]', (event) => {
		this.hideTooltipForElement(event.currentTarget);
	});

	this.$search.on("input", () => {
		this._search = this.$search.val();
		this.updateSearchClearButton();
		this.renderContainerList();
	});

	this.$root.on("click", '[data-action="clear-search"]', (event) => {
		event.stopPropagation();
		this._search = "";
		if (this.$search) {
			this.$search.val("");
		}
		this.updateSearchClearButton();
		this.renderContainerList();
	});

	this.$root.on("click", '[data-action="refresh"]', () => {
		this.renderContainerList();
	});

	this.$root.on("click", '[data-action="focus"]', (event) => {
		event.stopPropagation();
		this.focusContainer($(event.currentTarget).data("container-id"));
	});

	this.$root.on("click", '[data-action="close"]', (event) => {
		event.stopPropagation();
		this.closeContainer($(event.currentTarget).data("container-id"));
	});

	this.$root.on("click", '[data-action="state"]', (event) => {
		event.stopPropagation();
		const $target = $(event.currentTarget);
		this.setContainerState($target.data("container-id"), $target.data("state"));
	});

	this.$root.on("click", ".container-list-item", (event) => {
		const containerID = $(event.currentTarget).data("container-id");
		this.focusContainer(containerID);
	});

	this.$root.on("mouseenter", ".container-list-item", (event) => {
		const containerID = $(event.currentTarget).data("container-id");
		this._hoveredContainerID = this.normalizeContainerID(containerID);
		this._pauseAutoRefresh = true;
	});

	this.$root.on("mouseleave", ".container-list-item", () => {
		this._hoveredContainerID = undefined;
		this._pauseAutoRefresh = false;
		this.renderContainerList();
	});

	this.$list.on("scroll", () => {
		this.updateSummary();
	});

	this._autoRefreshInterval = setInterval(() => {
		if (this._pauseAutoRefresh) {
			return;
		}
		this.renderContainerList();
	}, this._refreshIntervalMs);

	return this.$root;
};

ContainerListViewRenderer.prototype.doUpdate = function (model) {
	this._options = _.defaultsDeep(model.options, this._options);
	this._includeSelf = _.resolve(this._options.includeSelf, false) === true;
	this._search = _.get(model, "search", _.get(this._options, "search", ""));
	this._excludeContainerIDs = this.parseExcludedContainerIDs(
		_.get(this._options, "exclude", [])
	);
	this._tooltips = this.parseTooltips(this._options);

	this.updateRefreshTooltip();

	if (_.isString(this._search) && this._search.length > 0) {
		if (this.$search) {
			this.$search.val(this._search);
		}
	}
	this.updateSearchClearButton();

	const refreshIntervalMs = _.parseInt(
		_.get(this._options, "refreshIntervalMs", this._refreshIntervalMs)
	);
	const nextIntervalMs = refreshIntervalMs >= 250 ? refreshIntervalMs : 1000;
	if (nextIntervalMs !== this._refreshIntervalMs) {
		this._refreshIntervalMs = nextIntervalMs;
		if (this._autoRefreshInterval) {
			clearInterval(this._autoRefreshInterval);
		}
		this._autoRefreshInterval = setInterval(() => {
			if (this._pauseAutoRefresh) {
				return;
			}
			this.renderContainerList();
		}, this._refreshIntervalMs);
	}

	this.renderContainerList();
	return true;
};

ContainerListViewRenderer.prototype.focusContainer = function (containerID) {
	if (!_.isStringOrNumber(containerID)) {
		return;
	}
	this.viewmanager.focusContainer(containerID);
	this.renderContainerList();
};

ContainerListViewRenderer.prototype.closeContainer = function (containerID) {
	if (!_.isStringOrNumber(containerID)) {
		return;
	}
	this.viewmanager.closeContainer(containerID, "user");
	this.renderContainerList();
};

ContainerListViewRenderer.prototype.setContainerState = function (
	containerID,
	state
) {
	if (!_.isStringOrNumber(containerID)) {
		return;
	}

	if (
		!_.includes(
			[
				ViewContainer.State.MAXIMIZED,
				ViewContainer.State.MINIMIZED,
				ViewContainer.State.NORMALIZED,
			],
			state
		)
	) {
		return;
	}

	const container = this.viewmanager.getContainer(containerID);
	if (!container || !_.isFunction(container.setState)) {
		return;
	}

	container.setState(state);
	if (_.isFunction(container.updateState)) {
		container.updateState("state", state);
	}

	this.renderContainerList();
};

ContainerListViewRenderer.prototype.matchesSearch = function (item) {
	if (!_.isString(this._search) || _.trim(this._search) === "") {
		return true;
	}
	const search = _.trim(this._search).toLowerCase();

	const fields = _.compact([
		item.title,
		item.id,
		item.area,
		item.viewtype,
		item.instanceID,
		item.functionID,
	])
		.join(" ")
		.toLowerCase();

	return fields.indexOf(search) >= 0;
};

ContainerListViewRenderer.prototype.parseExcludedContainerIDs = function (
	excludedIDs
) {
	const normalizedIDs = DEFAULT_EXCLUDED_CONTAINER_IDS.slice();

	const appendID = (value) => {
		if (!_.isStringOrNumber(value)) {
			return;
		}
		const id = _.trim(`${value}`);
		if (!_.isEmpty(id)) {
			normalizedIDs.push(id);
		}
	};

	if (_.isArray(excludedIDs)) {
		_.forEach(excludedIDs, appendID);
	} else if (_.isStringOrNumber(excludedIDs)) {
		appendID(excludedIDs);
	}

	return _.uniq(normalizedIDs);
};

ContainerListViewRenderer.prototype.normalizeContainerID = function (
	containerID
) {
	if (!_.isStringOrNumber(containerID)) {
		return undefined;
	}

	const normalizedID = _.trim(`${containerID}`);
	return _.isEmpty(normalizedID) ? undefined : normalizedID;
};

ContainerListViewRenderer.prototype.syncRuntimeExcludedContainerIDs =
	function () {
		if (this._includeSelf) {
			this._runtimeExcludedContainerIDs = [];
			return;
		}

		const currentContainerID = this.normalizeContainerID(
			this.getCurrentContainerID()
		);
		if (!_.isString(currentContainerID)) {
			this._runtimeExcludedContainerIDs = [];
			return;
		}

		this._runtimeExcludedContainerIDs = [currentContainerID];
	};

ContainerListViewRenderer.prototype.getEffectiveExcludedContainerIDs =
	function () {
		this.syncRuntimeExcludedContainerIDs();
		return _.uniq(
			this._excludeContainerIDs.concat(this._runtimeExcludedContainerIDs)
		);
	};

ContainerListViewRenderer.prototype.parseTooltips = function (options) {
	const getTooltip = (key) => {
		const value = _.get(options, key, "");
		if (!_.isStringOrNumber(value)) {
			return "";
		}
		return _.trim(`${value}`);
	};

	return {
		refresh: getTooltip("ttRefresh"),
		focus: getTooltip("ttFocus"),
		maximize: getTooltip("ttMaximize"),
		minimize: getTooltip("ttMinimize"),
		normalize: getTooltip("ttNormalize"),
		close: getTooltip("ttClose"),
	};
};

ContainerListViewRenderer.prototype.applyTooltip = function ($button, tooltip) {
	if (!_.isString(tooltip) || _.isEmpty(tooltip)) {
		return;
	}

	$button.attr("data-bs-html", true);
	$button.attr("data-bs-toggle", "tooltip");
	$button.attr("data-bs-placement", "top");
	$button.attr("data-bs-trigger", "hover");
	$button.attr("data-bs-title", tooltip);
	$button.attr("title", tooltip);
};

ContainerListViewRenderer.prototype.hideTooltipForElement = function (element) {
	if (!element) {
		return;
	}

	const $element = $(element);
	if (
		typeof document !== "undefined" &&
		document.activeElement === element &&
		_.isFunction(element.blur)
	) {
		element.blur();
	}

	const bootstrapGlobal =
		typeof window !== "undefined" ? window.bootstrap : undefined;
	if (
		bootstrapGlobal &&
		bootstrapGlobal.Tooltip &&
		_.isFunction(bootstrapGlobal.Tooltip.getInstance)
	) {
		const tooltipInstance = bootstrapGlobal.Tooltip.getInstance(element);
		if (tooltipInstance && _.isFunction(tooltipInstance.hide)) {
			tooltipInstance.hide();
		}
	}

	if (_.isFunction($element.tooltip)) {
		try {
			$element.tooltip("hide");
		} catch (error) {
			// Ignore if tooltip plugin is not active on this element.
		}
	}

	const describedBy = $element.attr("aria-describedby");
	if (_.isString(describedBy) && !_.isEmpty(describedBy)) {
		_.forEach(_.compact(describedBy.split(/\s+/)), (tooltipID) => {
			const tooltipElement =
				typeof document !== "undefined"
					? document.getElementById(tooltipID)
					: null;
			if (tooltipElement && tooltipElement.parentNode) {
				tooltipElement.parentNode.removeChild(tooltipElement);
			}
		});
		$element.removeAttr("aria-describedby");
	}
};

ContainerListViewRenderer.prototype.hideAllTooltips = function () {
	if (!this.$root) {
		return;
	}

	this.$root.find('[data-bs-toggle="tooltip"]').each((index, element) => {
		this.hideTooltipForElement(element);
	});
};

ContainerListViewRenderer.prototype.updateRefreshTooltip = function () {
	if (!this.$refresh) {
		return;
	}

	this.$refresh.removeAttr("data-bs-html");
	this.$refresh.removeAttr("data-bs-toggle");
	this.$refresh.removeAttr("data-bs-placement");
	this.$refresh.removeAttr("data-bs-trigger");
	this.$refresh.removeAttr("data-bs-title");
	this.$refresh.removeAttr("title");

	this.applyTooltip(this.$refresh, this._tooltips.refresh);
};

ContainerListViewRenderer.prototype.updateSearchClearButton = function () {
	if (!this.$searchClear) {
		return;
	}

	const hasSearch = _.isString(this._search) && _.trim(this._search) !== "";
	this.$searchClear.toggleClass("d-none", !hasSearch);
};

ContainerListViewRenderer.prototype.getFilteredItemCount = function () {
	return _.isInteger(this._filteredCount) ? this._filteredCount : 0;
};

ContainerListViewRenderer.prototype.updateSummary = function () {
	if (!this.$summary) {
		return;
	}

	const visibleCount = this.getFilteredItemCount();
	this.$summary.text(
		this.language.translate(`containerListCountVisible`, {visibleCount, totalCount: this._totalCount})
	);
};

ContainerListViewRenderer.prototype.syncAutoRefreshState = function (
	visibleContainers
) {
	if (!this._pauseAutoRefresh) {
		return;
	}

	if (
		!_.isString(this._hoveredContainerID) ||
		_.isEmpty(this._hoveredContainerID)
	) {
		this._pauseAutoRefresh = false;
		return;
	}

	const hoveredContainerIsVisible = _.some(visibleContainers, (item) => {
		return this.normalizeContainerID(item.id) === this._hoveredContainerID;
	});

	if (!hoveredContainerIsVisible) {
		this._hoveredContainerID = undefined;
		this._pauseAutoRefresh = false;
	}
};

ContainerListViewRenderer.prototype.getCurrentContainerID = function () {
	const currentContainer = this.viewmanager.getViewContainer(
		this.getInstanceID()
	);
	return _.get(currentContainer, "id");
};

ContainerListViewRenderer.prototype.renderContainerList = function () {
	if (!this.$list || !this.$summary) {
		return;
	}

	this.hideAllTooltips();

	const currentContainerID = this.normalizeContainerID(
		this.getCurrentContainerID()
	);
	let containers = this.viewmanager.getOpenContainers(
		this.getEffectiveExcludedContainerIDs()
	);

	if (!this._includeSelf && _.isString(currentContainerID)) {
		containers = _.filter(
			containers,
			(item) => this.normalizeContainerID(item.id) !== currentContainerID
		);
	}

	const filtered = _.filter(containers, (item) => this.matchesSearch(item));
	this.syncAutoRefreshState(filtered);
	this._totalCount = containers.length;
	this._filteredCount = filtered.length;
	this.$list.empty();

	if (filtered.length === 0) {
		this.$list.append(
			$(
				'<div class="container-list-empty p-2 text-muted">No matching panels.</div>'
			)
		);
		this.updateSummary();
		return;
	}

	_.forEach(filtered, (item) => {
		const meta = _.compact([item.id, item.viewtype, item.area]).join(" | ");

		const $item = $(
			'<div class="container-list-item d-flex align-items-start justify-content-between p-2">'
		);
		const $main = $(
			'<div class="container-list-main flex-grow-1 overflow-hidden">'
		);
		const $title = $('<div class="container-list-title text-truncate">');
		const $meta = $(
			'<div class="container-list-meta small text-muted text-truncate">'
		);
		const $actions = $(
			'<div class="container-list-actions btn-group btn-group-sm" role="group" aria-label="Container actions">'
		);
		const $focus = $(
			'<button type="button" class="btn btn-sm btn-primary" aria-label="Focus panel"><i class="fa fa-crosshairs fa-solid fa-arrows-to-eye"></i></button>'
		);
		const $maximize = $(
			'<button type="button" class="btn btn-sm btn-secondary" aria-label="Maximize panel"><i class="fa fa-expand"></i></button>'
		);
		const $minimize = $(
			'<button type="button" class="btn btn-sm btn-secondary" aria-label="Minimize panel"><i class="fa fa-minus"></i></button>'
		);
		const $normalize = $(
			'<button type="button" class="btn btn-sm btn-secondary" aria-label="Normalize panel"><i class="fa fa-compress"></i></button>'
		);
		const $close = $(
			'<button type="button" class="btn btn-sm btn-danger" aria-label="Close panel"><i class="fa fa-times fa-solid fa-xmark"></i></button>'
		);

		$item.attr("data-container-id", item.id);
		$focus.attr("data-action", "focus").attr("data-container-id", item.id);
		$maximize
			.attr("data-action", "state")
			.attr("data-state", ViewContainer.State.MAXIMIZED)
			.attr("data-container-id", item.id);
		$minimize
			.attr("data-action", "state")
			.attr("data-state", ViewContainer.State.MINIMIZED)
			.attr("data-container-id", item.id);
		$normalize
			.attr("data-action", "state")
			.attr("data-state", ViewContainer.State.NORMALIZED)
			.attr("data-container-id", item.id);
		$close.attr("data-action", "close").attr("data-container-id", item.id);

		if (this.normalizeContainerID(item.id) === currentContainerID) {
			$item.addClass("container-list-item-self");
			$close.prop("disabled", true);
		}
		if (item.closable === false) {
			$close.prop("disabled", true);
		}

		$maximize.prop("disabled", item.state === ViewContainer.State.MAXIMIZED);
		$minimize.prop("disabled", item.state === ViewContainer.State.MINIMIZED);
		$normalize.prop("disabled", item.state === ViewContainer.State.NORMALIZED);

		this.applyTooltip($focus, this._tooltips.focus);
		this.applyTooltip($maximize, this._tooltips.maximize);
		this.applyTooltip($minimize, this._tooltips.minimize);
		this.applyTooltip($normalize, this._tooltips.normalize);
		this.applyTooltip($close, this._tooltips.close);

		$title.text(item.title || item.id);
		$meta.text(meta);

		$main.append($title);
		$main.append($meta);
		$actions.append($focus);
		$actions.append($maximize);
		$actions.append($minimize);
		$actions.append($normalize);
		$actions.append($close);

		$item.append($main);
		$item.append($actions);

		this.$list.append($item);
	});

	this.updateSummary();
};

module.exports = ContainerListViewRenderer;
